"use strict";

exports.__esModule = true;
exports["default"] = void 0;

/**
 * Tests a prop of type string contains a valid number.
 */
function positiveNonZeroInt(props, propName, componentName) {
  var errorMessage = ["Invalid prop " + propName + " supplied to " + componentName + "."];
  var prop = props[propName];

  if (typeof prop !== 'number') {
    errorMessage.push("Prop is of type " + typeof prop + ".");
  }

  if (prop < 1) {
    errorMessage.push('Prop is less than 1.');
  }

  if (!Number.isInteger(prop)) {
    errorMessage.push('Prop is a float.');
  }

  errorMessage.push('Expected a positive, non-zero integer.');
  if (errorMessage.length > 2) return new Error(errorMessage.join(' '));
  return null;
}

function positiveNonZeroIntPropType(props, propName, componentName) {
  if (props[propName] === undefined || props[propName] === null) return null;
  return positiveNonZeroInt(props, propName, componentName);
}

positiveNonZeroIntPropType.isRequired = function isRequired(props, propName, componentName) {
  return positiveNonZeroIntPropType(props, propName, componentName);
};

var _default = positiveNonZeroIntPropType;
exports["default"] = _default;